import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';
import {
  Language,
  WebOutlined,
} from '@material-ui/icons';

export default {
  name: 'Smit Shah',
  title: 'Enthusiast MERN developer',
  birthday: '9th October, 2000',
  email: 'smit.web.cs@gmail.com',
  address: 'Vadodara, Gujarat',
  phone: '+91 9904227623',

  socials: {
    Linkedin: {
      link: 'https://www.linkedin.com/in/smit-shah-a5bb28199/',
      text: 'SmitShah',
      icon: <LinkedInIcon />,
    },
    Instagram: {
      link: 'https://www.instagram.com/',
      text: 'smitshah.jsx',
      icon: <InstagramIcon />,
    },
    Youtube: {
      link: 'https://www.youtube.com/channel/UC2tTvU2WXHHVfjjyz9kr8RQ',
      text: 'Think & Learn',
      icon: <YouTubeIcon />,
    },
    Github: {
      link: 'https://github.com/SmitShah090',
      text: 'SmitShah090',
      icon: <GitHubIcon />,
    },
  },

  about: `I am Smit Shah pursuing my B.Tech in Computer Science & Engineering at Charotar University of Science and Technology, Anand. 
          I have a keen interest towards MERN Stack Development and also I am very eager to learn UI design for Websites and apps. 
          I never stopped engaging my passion to help others and solve them problems. 
          Now I'm Proficient in creative design and building responsive web apps.`,

  experiance: [
    {
      title: 'Netstar Overseas Software Services India LLP',
      date: 'May/2020 - June/2020',
      description: `I had a good experience as an Intern's work at US Company`,
    },
    {
      title: 'Aavatto ',
      date: 'June 2021 - present',
      description: 'Always work with new designs, new concepts.',
    },
  ],

  educations: [
    {
      title: 'Bachelor of Technology, Computer Science and Engineering',
      date: '2018 - 2022',
      description: 'Charotar University of Science and Technology ',
    },
    {
      title: 'Higher Secondary Education',
      date: '2016 - 2018',
      description: 'Narayan Vidhyalaya',
    },
    {
      title: 'Secondary Education',
      date: '2003 - 2016',
      description: 'Shree M.H.Dayaram Sharda Mandir',
    },
  ],

  services: [
    {
      title: 'Frontend Development',
      description: 'I develop websites, keeping them unique, functional and modern.',
      icon: <WebOutlined />,
    },
    {
      title: 'Responsive & PWA',
      description: 'Progressive Web Application in normal and responsive for all devices.',
      icon: <MobileFriendlyIcon fontsize="large" />,
    },
    {
      title: 'Full-stack Development',
      description: 'Crazy Full Stack Developer Who Wants to explore MERN Stack',
      icon: <ImportantDevicesIcon />,
    },
  ],

  projects: [
    {
      tag: 'React',
      image: 'https://i.postimg.cc/tTvjDMZ8/weather-app-1.jpg',
      images: [
        'https://i.postimg.cc/44Hp6bXk/weather-app-1-1832x937.jpg',
        'https://i.postimg.cc/nhGWHfWk/weather-app-3.jpg',
      ],
      title: 'Weather web-app',
      caption: 'To find a weather information',
      description1: 'This weather web application is used for get the information of weather (like High temp, Low temp, Humidity, Pressure, Sunrise and Sunset time) for a particular city around the world.',
      description2: 'Created :  Dec/2020',
      description3: 'Technologies Used :  React Js, Material-UI, Axios',
      links: [
        {link: 'https://youtu.be/uSv7R00FjDg', icon: <YouTubeIcon />},
        {
          link: 'https://github.com/SmitShah090/Weather-App',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://quirky-dijkstra-321666.netlify.app',
          icon: <Language />,
        },
      ],
    },
    {
      tag: 'UI Design',
      image: 'https://i.postimg.cc/gkr63BVv/Placement-Website-1.png',
      images: [
        'https://i.postimg.cc/gkr63BVv/Placement-Website-1.png',
        'https://i.postimg.cc/9XgDXt6z/Placement-Website-2.png',
        'https://i.postimg.cc/8CG5Xy6X/Placement-Website-3.png',
        'https://i.postimg.cc/qqwS0vbC/Placement-Website-4.jpg',
        'https://i.postimg.cc/HsLPXHvB/Placement-Website-5.jpg'
      ],

      title: 'Placement Website Design',
      caption: 'Ui Design of Placement Website',
      description1: 'Here is my UI design of Placement Website which helps to find the Job of Our University Student as well as employees who want hire the student for their companies with specific role.',
      description2: 'Created :  March/2020',
      description3: 'Tool Used :  Figma, Framer',
      links: [
        {link: 'https://youtu.be/JpAheNDGS40', icon: <YouTubeIcon />},
        {link: 'https://framer.com/share/CSI-Placement-Website--1yMnr1AToctXWMkzqVdv/d3DGowvgTpi26sjBxPlyPQ-1%3A8080l2qeo957bv', icon: <Language />},
      ],
    },
    {
      tag: 'React',
      image: 'https://i.postimg.cc/k41jkryF/covid-app-1.jpg',
      images: [
        'https://i.postimg.cc/dQgLwbMg/covid-app-1-1832x937.jpg',
        'https://i.postimg.cc/DyVDFhTB/covid-app-3.jpg',
      ],

      title: 'Covid-19 tracker',
      caption: 'To find latest covid updates',
      description1: `Here's the covid-19 tracker web application. The main functionalities are get the information about covid-19 cases(Daily Update) across the world as well as each states of India.`,
      description2: 'Created :  Jan/2021 - Feb/2021',
      description3: 'Technologies Used :  React Js,React-router, Material-UI, Axios',
      links: [
        {link: 'https://youtu.be/fkG0GLcU8OY', icon: <YouTubeIcon />},
        {
          link: 'https://github.com/SmitShah090/covid19-tracker-app',
          icon: <GitHubIcon />,
        },
        {link: 'https://covid-19-app.ml/', icon: <Language />},
      ],
    },
    {
      tag: 'React',
      image: 'https://i.postimg.cc/kXB5Y9hz/Entertainment-Hub-1.jpg',
      images: [
        'https://i.postimg.cc/kXB5Y9hz/Entertainment-Hub-1.jpg',
        'https://i.postimg.cc/4dgDtvrs/Entertainment-Hub-2.jpg',
        'https://i.postimg.cc/bYL7DtLf/Entertainment-Hub-3.jpg',
        'https://i.postimg.cc/sf0jhqDc/Entertainment-Hub-4.jpg',
      ],

      title: 'Entertainment Hub',
      caption: 'Get the details of Series & Movies.',
      description1: 'This is the Entertainment Hub web app which is contained TV series, Movies also with trending Data. Also includes one search page where you can search different TV Series & Movies.',
      description2: 'Created :  Feb/2021',
      description3: 'Technologies Used :  React Js,React-router, Material-UI, Axios',
      links: [
        {link: 'https://youtu.be/wvLC83fz71o', icon: <YouTubeIcon />},
        {
          link: 'https://github.com/SmitShah090/covid19-tracker-app',
          icon: <GitHubIcon />,
        },
        {link: 'https://entertainmentapp.ml/', icon: <Language />},
      ],
    },
    {
      tag: 'UI Design',
      image: 'https://i.postimg.cc/qMHKDmBP/Food-Odering-App-1.png',
      images: [
        'https://i.postimg.cc/qMHKDmBP/Food-Odering-App-1.png',
        'https://i.postimg.cc/FshRJwHH/Food-Odering-App-2.png',
        'https://i.postimg.cc/Jnw772Fm/Food-Odering-App-3.jpg',
        'https://i.postimg.cc/hjqgR7Jt/Food-Odering-App-4.jpg',
      ],

      title: 'Food Odering App Design',
      caption: 'Ui Design of Food Odering App',
      description1: 'Here is my first UI design on Food Odering App.',
      description2: 'Created :  Dec/2020',
      description3: 'Tool Used :  Figma, Framer',
      links: [
        {link: 'https://youtu.be/OYCDgxIiomY', icon: <YouTubeIcon />},
        {link: 'https://framer.com/share/rxemFjRWIeIoxIqSVCIy/gY8O5giYL1ZmydD0R7QRB6-1%3A20og463k43968', icon: <Language />},
      ],
    },
    {
      tag: 'MERN Stack',
      image: 'https://i.postimg.cc/RFRrFYjn/Internship-Portal-6.jpg',
      images: [
        'https://i.postimg.cc/NjJkgkJf/Internship-Portal-1.jpg',
        'https://i.postimg.cc/8kRdFSKY/Internship-Portal-2.jpg',
        'https://i.postimg.cc/qv52fMqN/Internship-Portal-3.jpg',
        'https://i.postimg.cc/qq43cNb5/Internship-Portal-4.jpg',
        'https://i.postimg.cc/Pr6wZrmS/Internship-Portal-5.jpg'
      ],

      title: 'Internship Portal',
      caption: 'Used to apply internships',
      description1: `This website focuses on providing an opportunity to the students of our university to apply for summer internships. Students can create their profile and look for the internships provided by several companies and apply according to their skills and convenience. They can upload their resumes to make it easier for the companies to review at ease. This platform reduces the complexity and time for students to apply for internships at one hub.
                      ( This website is currently under development, so if you have any suggestions then dm me on linkedin/instagram.)`,
      description2: 'Created :  Mar/2021-Now',
      description3: 'Technologies Used :  React Js,React-router, Material-UI, Axios, Node JS, Express JS, MOngoDB',
      links: [
        {link: 'https://youtu.be/pgIfYzolQio', icon: <YouTubeIcon />},
        {
          link: 'https://github.com/SmitShah090/Internship-Portal',
          icon: <GitHubIcon />,
        },
/*         {link: 'https://entertainmentapp.ml/', icon: <Language />},
 */      ],
    },
  ],
};
